module.exports = __webpack_public_path__ + "img/foto aire libre_thumb.fce5333d.jpg";